"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointGoodsListRequest = void 0;
var PointGoodsListRequest = /** @class */ (function () {
    function PointGoodsListRequest() {
    }
    return PointGoodsListRequest;
}());
exports.PointGoodsListRequest = PointGoodsListRequest;
//# sourceMappingURL=pointGoodsList.request.js.map